import { render, staticRenderFns } from "./OrderDetailsModal.vue?vue&type=template&id=654e14b1&"
import script from "./OrderDetailsModal.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports